@if (viewStateSupportsLayout() && shouldShowLayoutOptions()) {
    <ng-container>
        <st-list-drop-down
            class="st-playbook-view-options__layout"
            labelPosition="after"
            [value]="viewStateLayoutValue()"
            [label]="languageSettings?.PSTWebViewLabel"
            [list]="viewStateLayoutOptions()?.Options"
            (valueOutput)="updateLayout($event)" />
    </ng-container>
}

@if (viewStateSupportsGroupBy()) {
    <ng-container>
        <st-list-drop-down
            class="st-playbook-view-options__group-by"
            mobileIcon="workspaces"
            [disabled]="groupByDisabled()"
            [label]="languageSettings?.PSTWebGroupByLabel"
            [value]="viewStateGroupByValue()"
            [list]="viewStateGroupByOptions()?.Options"
            (valueOutput)="updateGroupBy($event)" />
    </ng-container>
}

@if (viewStateSupportsGroupByOrder()) {
    <ng-container>
        <button
            mat-icon-button
            [disabled]="(viewStateGroupByOrderDisabled() && isDateField()) || viewStateSortingManual()"
            [matTooltip]="viewStateGroupByOrderTitle()"
            (click)="updateGroupSortOrder()">
            <mat-icon class="material-symbols-outlined">{{ selectCurrentGroupByOrderIcon() }}</mat-icon>
        </button>
    </ng-container>
}

@if (viewStateSupportsSortBy()) {
    <ng-container>
        <st-list-drop-down
            class="st-playbook-view-options__sort-by"
            mobileIcon="sort"
            [disabled]="sortByDisabled()"
            [value]="viewStateSortByValue()"
            [label]="languageSettings?.PSTWebSortByLabel"
            [list]="viewStateSortByOptions()?.Options"
            (valueOutput)="updateSortBy($event)" />
    </ng-container>
}

@if (viewStateSupportsSortByOrder()) {
    <ng-container>
        <button
            mat-icon-button
            [disabled]="viewStateSortDisabled()"
            [matTooltip]="viewStateSortByOrderTitle()"
            (click)="updateSortOrder()">
            <mat-icon class="material-symbols-outlined">{{ selectCurrentSortByOrderIcon() }}</mat-icon>
        </button>
    </ng-container>
}

@if (newItemsCount()) {
    <button
        mat-button
        class="st-playbook-view-options-button-new-items"
        [matMenuTriggerFor]="newItemsMenu"
        (menuOpened)="clickNewItemsBtn()">
        {{ newItemsCountLabel() }}
    </button>
    <mat-menu
        #newItemsMenu="matMenu"
        class="st-playbook-view-options-button-new-items__menu">
        <ng-template matMenuContent>
            @if (newItemsLoading()) {
                <div class="st-playbook-view-options-button-new-items__loading">{{ languageSettings.PSTWebLoadingLabel }}</div>
            }
            @for (item of newlyAddedItems(); track $index) {
                @switch (item?.Type) {
                    @case (ObjectTypes.TOPIC) {
                        <st-topic-item
                            small="true"
                            [data]="item"
                            [cardViewType]="cardViewType.SMALL"
                            (topicItemClicked)="openTopic(item)" />
                    }
                    @case (ObjectTypes.SCRIPT) {
                        <st-story-item
                            small="true"
                            [cardViewType]="cardViewType.SMALL"
                            [data]="item"
                            (itemClicked)="openStory(item, undefined, true)" />
                    }
                    @case (ObjectTypes.ASSIGNMENT) {
                        <st-assignment-item
                            small="true"
                            [data]="item"
                            [cardViewType]="cardViewType.SMALL"
                            (assignmentOpenEmitter)="onAssignmentOpenHandler(item)" />
                    }
                }
            }
        </ng-template>
    </mat-menu>
}
